<template>
    <v-layout id="augmentations_publish" row wrap>
        <v-flex xs0 md1 lg2 />
        <v-flex xs12 md10 lg8>
            <v-card class="custom_card">
                <v-card-text>
                    <h3>Intégration</h3>
                    <p>Copiez et collez le code suivant dans votre page web</p>
                    <v-text-field id="link_blinkl" v-model="blinklUrl" class="input"
                                  filled auto-grow single-line :readonly="true" />
                </v-card-text>
                <v-card-actions>
                    <v-layout row wrap>
                        <v-flex xs6>
                            <v-btn class="custom_btn_position custom_btn_color_red" @click="copyLink">
                                <div class="fas fa-copy" />
                                <span v-if="!isMobile">Copier</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs6>
                            <v-btn class="custom_btn_position custom_btn_color_blue" @click="localTestExperience">
                                <div class="fas fa-desktop" />
                                <span v-if="!isMobile">Tester</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
            <!--            <v-card class="custom_card">-->
            <!--                <v-layout row wrap>-->
            <!--                    <v-flex xs12>-->
            <!--                        <div class="container">-->
            <!--                            <h3>Personalisation du bouton</h3>-->
            <!--                        </div>-->
            <!--                    </v-flex>-->
            <!--                    <v-flex xs12 sm4 class="custom_flex">-->
            <!--                        <div class="center_flex_content">-->
            <!--                            <p>Couleur des bordures</p>-->
            <!--                            <transition name="fade" mode="out-in">-->
            <!--                                <div class="box_color_picker" :style="'background-color: ' + colorBorder"-->
            <!--                                     @click="colorEdit = colorBorder, indexColorEdit = 0" />-->
            <!--                            </transition>-->
            <!--                            <p>Couleur de font</p>-->
            <!--                            <transition name="fade" mode="out-in">-->
            <!--                                <div class="box_color_picker" :style="'background-color: ' + colorFont"-->
            <!--                                     @click="colorEdit = colorFont, indexColorEdit = 1" />-->
            <!--                            </transition>-->
            <!--                            <p>Couleur du logo</p>-->
            <!--                            <transition name="fade" mode="out-in">-->
            <!--                                <div class="box_color_picker" :style="'background-color: ' + colorLogo"-->
            <!--                                     @click="colorEdit = colorLogo, indexColorEdit = 2" />-->
            <!--                            </transition>-->
            <!--                        </div>-->
            <!--                    </v-flex>-->
            <!--                    <v-flex xs12 sm4 class="custom_flex">-->
            <!--                        <chrome-picker :value="colorEdit" @input="updateColorEdit($event)" />-->
            <!--                    </v-flex>-->
            <!--                    <v-flex xs12 sm4 class="custom_flex">-->
            <!--                        <div id="Blinkl">-->
            <!--                            <div id="Blinkl_Main_Button">-->
            <!--                                <svg id="Blinkl_Logo_Main" xmlns="http://www.w3.org/2000/svg" version="1.1"-->
            <!--                                     x="0px" y="0px" viewBox="0 0 12000 12000" xml:space="preserve">-->
            <!--                                    <path fill="#ffffff"-->
            <!--                                          d="M369.19,556.13c-113.06,5.24-205.65-85.06-205.65-198.25V119.64A81.76,81.76,0,0,0,0,118.87L0,359.94C0,558.73,161.15,719.88,359.94,719.88a358.5,358.5,0,0,0,147.11-31.37,8.51,8.51,0,0,0,5.05-7.77V496.3a4.56,4.56,0,0,0-7.9-3.1A195.8,195.8,0,0,1,369.19,556.13Z" />-->
            <!--                                    <path fill="#ffffff"-->
            <!--                                          d="M350.69,163.75C463.75,158.51,556.34,248.81,556.34,362V600.24a81.76,81.76,0,0,0,163.52.77l0-241.07C719.88,161.15,558.73,0,359.94,0A358.65,358.65,0,0,0,212.83,31.36a8.53,8.53,0,0,0-5.05,7.78V223.58a4.55,4.55,0,0,0,7.89,3.1A195.84,195.84,0,0,1,350.69,163.75Z" />-->
            <!--                                </svg>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </v-flex>-->
            <!--                    <v-flex xs12>-->
            <!--                        <v-layout class="custom_layout_btn_edit">-->
            <!--                            <v-flex xs2 />-->
            <!--                            <v-flex xs4>-->
            <!--                                <v-btn class="custom_btn_position custom_btn_color_blue" disabled>-->
            <!--                                    <div class="fas fa-save" />-->
            <!--                                    <span v-if="!isMobile">Sauvegarder</span>-->
            <!--                                </v-btn>-->
            <!--                            </v-flex>-->
            <!--                            <v-flex xs4>-->
            <!--                                <v-btn class="custom_btn_position custom_btn_color_blue" :loading="loadingExport"-->
            <!--                                       disabled @click="exportBtnBlinkl(this)">-->
            <!--                                    <div class="fas fa-file-export" />-->
            <!--                                    <span v-if="!isMobile">Exporter</span>-->
            <!--                                </v-btn>-->
            <!--                            </v-flex>-->
            <!--                            <v-flex xs2 />-->
            <!--                        </v-layout>-->
            <!--                    </v-flex>-->
            <!--                </v-layout>-->
            <!--            </v-card>-->
        </v-flex>
        <v-flex xs0 md1 lg2 />
    </v-layout>
</template>

<script>
    import { saveAs } from 'file-saver';
    import html2canvas from 'html2canvas';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'AugmentationsTabPublish',
        components: {
            // 'chrome-picker': () => import('vue-color/src/components/Chrome.vue')
        },
        data: () => ({
            colorBorder: '#FFFFFF',
            colorFont: '#000000C4',
            colorLogo: '#FFFFFF',
            colorEdit: '',
            indexColorEdit: -1,
            loadingExport: false
        }),
        computed: {
            ...mapGetters('augmentations', ['currentExperienceToken', 'currentOrganisationToken']),
            ...mapGetters('app', ['profil', 'isMobile']),
            blinklUrl: function () {
                return "<script id='Blinkl_Script' type='module'" + this.connectPath + this.colorPath + '><' + '/script>';
            },
            connectPath: function () {
                return " src='" + window.location.origin + "/client/main.js' " +
                    "orga='" + this.currentOrganisationToken + "' " +
                    "campaign='" + this.currentExperienceToken + "' ";
            },
            colorPath: function () {
                return " color-logo='" + this.colorLogo + "' color-background='" + this.colorFont +
                    "' color-border='" + this.colorBorder + "' ";
            }
        },
        watch: {
            colorLogo: function (newValue) {
                let elements = this.$el.querySelector('#Blinkl_Logo_Main').querySelectorAll('path');
                elements.forEach((element) => {
                    element.setAttribute('style', 'fill:' + newValue);
                });
            },
            colorFont: function (newValue) {
                this.$el.querySelector('#Blinkl_Main_Button').style.backgroundColor = newValue;
            },
            colorBorder: function (newValue) {
                this.$el.querySelector('#Blinkl_Main_Button').style.borderColor = newValue;
            }
        },
        methods: {
            ...mapActions('experiences', ['modeTestExperience']),
            copyLink: function () {
                document.getElementById('link_blinkl').select();
                document.execCommand('copy');
                this.$toasted.success('Vous avez copié le lien de test de Blinkl');
            },
            localTestExperience: function () {
                this.modeTestExperience({
                    experienceToken: this.currentExperienceToken,
                    organisationToken: this.currentOrganisationToken
                });
            },
            updateColorEdit: function (e) {
                this.colorBorder = this.indexColorEdit === 0 ? e.hex8 : this.colorBorder;
                this.colorFont = this.indexColorEdit === 1 ? e.hex8 : this.colorFont;
                this.colorLogo = this.indexColorEdit === 2 ? e.hex8 : this.colorLogo;
                this.colorEdit = e.hex8;
            },
            exportBtnBlinkl: function () {
                let _this = this;
                this.loadingExport = true;
                setTimeout(function () {
                    html2canvas(_this.$el.querySelector('#Blinkl_Main_Button'), {
                        scale: 10,
                        backgroundColor: '#FFFFFF'
                    }).then(function (canvas) {
                        canvas.toBlob(function (blob) {
                            saveAs(blob, 'BlinklButton.png');
                            _this.loadingExport = false;
                            _this.$toasted.success('L\'image a correctement été exporter');
                        });
                    }).catch(function (err) {
                        _this.loadingExport = true;
                        _this.$toasted.error(err);
                    });
                }, 200);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .container {
        padding: 25px;
        max-width: 100% !important;
    }

    .custom_card {
        margin: 30px;
        padding-bottom: 20px;
        background-color: #FFF;
        border-radius: 5px;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
    }

    .custom_card .v-card__text {
        padding-bottom: 0 !important;
    }

    .custom_card .v-card__actions {
        padding: 0 30px !important;
    }

    .vc-chrome {
        left: 50%;
        transform: translateX(-50%);
        position: relative;
    }

    .box_color_picker {
        height: 30px;
        border: 2px black solid;
        border-radius: 6px;
        width: 80%;
        left: 50%;
        transform: translateX(-50%);
        position: relative;
        cursor: pointer;
        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, .3), 0 4px 8px rgba(0, 0, 0, .3);
        box-shadow: 0 0 2px rgba(0, 0, 0, .3), 0 4px 8px rgba(0, 0, 0, .3);
    }

    .box_color_picker.active {
        border: 2px rgb(22, 156, 235) solid;
    }

    .center_flex_content {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }

    .custom_layout_btn_edit {
        margin-top: 20px;
    }

    #Blinkl {
        padding: 20px;
        height: 100%;
        width: calc(100% - 80px);
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        position: relative;
        left: 50%;
        border-radius: 2px;
        background-color: #F1F1F1;
        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.3), 0 4px 8px rgba(0, 0, 0, 0.3);
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.3), 0 4px 8px rgba(0, 0, 0, 0.3);
    }

    #Blinkl_Main_Button {
        width: 150px;
        height: 150px;
        position: relative;
        border-radius: 50% 50%;
        border: white 7px solid;
        background-color: rgba(0, 0, 0, 0.8);
        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, .3), 0 4px 8px rgba(0, 0, 0, .3);
        box-shadow: 0 0 2px rgba(0, 0, 0, .3), 0 4px 8px rgba(0, 0, 0, .3);
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        overflow: hidden;
    }

    #Blinkl_Logo_Main {
        width: 1500px;
        top: 23px;
        left: 23px;
        position: relative;
    }

    #Blinkl_Logo_Main * {
        -webkit-animation-duration: 3s;
        animation-duration: 3s;
        -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
        animation-timing-function: cubic-bezier(0, 0, 1, 1);
    }

    .custom_flex {
        margin-top: 15px;
        margin-bottom: 15px;
    }
</style>
